<template>
  <div class="btn-wrapper" :class="{ 'btn-center': footerDataLen === 1 }">
    <div v-for="(item, key) in footerData" :key="key">
      <div
        class="btn"
        :style="getStyle(key, item)"
        @click.stop="handleGuide(key, item)"
        v-if="item.check"
      >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import openApp from "@/utils/openApp"
import { signIn } from "@/server/interfaces"

export default {
  name: "Footer",
  props: {
    footer: {
      type: Object,
      default: null
    },
    mainInfo: {
      type: Object
    }
  },
  data() {
    return {
      isShow: false,
      type: null,
      map: null
    }
  },
  computed: {
    ...mapGetters(["systemInfo"]),
    ...mapGetters("activityInfo", ["activityId"]),
    ...mapGetters("userInfo", ["userInfo"]),
    footerData () {
      const result = {}
      Object.keys(this.footer).forEach(item => {
        if (this.footer[item].check === true) {
          result[item] = this.footer[item]
        }
      })
      return result
    },
    footerDataLen() {
      return Object.keys(this.footerData).length
    }
  },
  mounted() {},
  methods: {
    ...mapMutations({
      showLoading: "loading/showLoading",
      hideLoading: "loading/hideLoading",
      showSignInPopup: "signInPopup/showSignInPopup"
    }),
    closePopup() {
      this.popType = ""
    },
    getStyle(key, item) {
      if (key === "locationSignIn") {
        const customUrl = item.setting.signInWord.button.url
        const defalutIcon = require("@/assets/images/icon_location.png")
        return {
          'background-image': customUrl ? `url(${customUrl})` : `url(${defalutIcon})`,
          'background-repeat': 'no-repeat',
          'background-position': 'top center',
          'background-size': '0.44rem'
        }
      }
    },
    handleGuide (type, info) {
      this.type = type
      type === "locationSignIn" && this.handleLocationSignIn(type, info)
    },
    async handleLocationSignIn(type, info) {
      if (this.systemInfo.isWx || this.systemInfo.isNfPlus) {
        if (!this.userInfo.userUuid) {
          await this.$store.dispatch("userInfo/getUserInfo")
        }
        if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
          await this.$store.dispatch("userInfo/getNfplusUserByLogin")
        }
        const { failSignIn, successSignIn, guideSignIn } = info.setting.signInWord
        this.showLoading("定位签到中...")
        const location = await this.getUserPosition()
        if (!location) {
          this.hideLoading()
          this.showSignInPopup({
            type: "guide",
            text: guideSignIn.word,
            icon: guideSignIn.image.url
          })
          return
        }
        let res = null
        try {
          res = await signIn({
            storeId: this.mainInfo.id,
            point: location
          })
        } catch (e) {
          res = { code: 500 }
        }
        this.hideLoading()
        if (res.code === 200) {
          this.showSignInPopup({
            type: "success",
            text: successSignIn.word,
            icon: successSignIn.image.url
          })
        } else {
          this.showSignInPopup({
            type: "fail",
            text: failSignIn.word,
            icon: failSignIn.image.url
          })
        }
      } else {
        this.openNfApp()
      }
    },
    openNfApp() {
      openApp({
        address:
          window.location.origin +
          window.location.pathname +
          this.$router.resolve({
            path: "/",
            query: { id: this.activityId }
          }).href
      }, this.activityId, 39)
    },
    getUserPosition() {
      /* global AMap */
      return new Promise(r => {
        this.map = new AMap.Map("map-container-fake", {
          center: [113.325, 23.137],
        })
        this.map.plugin("AMap.Geolocation", () => {
          let geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, // 是否使用高精度定位，默认:true
            timeout: 10000, // 超过10秒后停止定位，默认：无穷大
            maximumAge: 0, // 定位结果缓存0毫秒，默认：0
            convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: false, // 显示定位按钮，默认：true
            showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
            showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
            zoomToAccuracy: true, // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          })
          this.map.addControl(geolocation)
          geolocation.getCurrentPosition()
          AMap.event.addListener(geolocation, "complete", obj => {
            r({
              x: obj.position.lng,
              y: obj.position.lat
            })
          }) // 返回定位信息
          AMap.event.addListener(geolocation, "error", () => {
            r(null)
          }) // 返回定位出错信息
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.btn-wrapper {
  height: 100%;
  width: 100%;
  background: #fff;
  font-size: 0.26rem;
  color: #666;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn {
    text-align: center;
    position: relative;
    width: 1.6rem;
    height: 0.87rem;
    line-height: 1.4rem;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .locationSignIn {
    overflow: visible !important;
  }
}

.btn-center {
  justify-content: center;
}
</style>
